import { createFileRoute } from '@tanstack/react-router'
import { Crew } from '@/features/crew/views'
import { client } from '@/features/query/client'
import {
  referralControllerGetBalance,
  getReferralControllerGetBalanceQueryKey,
  getReferralControllerListQueryKey,
  referralControllerList,
} from '@/api/referrals/referrals'
import CoinAnimation from '@/ui/loader'

export const Route = createFileRoute('/crew')({
  component: RouteComponent,
  loader: async () => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getReferralControllerListQueryKey(),
        queryFn: () => referralControllerList(),
      }),
      client.prefetchQuery({
        queryKey: getReferralControllerGetBalanceQueryKey(),
        queryFn: () => referralControllerGetBalance(),
      }),
      client.prefetchInfiniteQuery({
        queryKey: [getReferralControllerListQueryKey(), 'ininity'],
        queryFn: ({ pageParam }) => {
          return referralControllerList({
            cursor: pageParam,
            take: 10,
          })
        },
        getNextPageParam: (lastPage) => {
          return lastPage?.nextCursor ? lastPage.nextCursor : undefined
        },
        initialPageParam: undefined as string | undefined,
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  return <Crew />
}
